import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";
import AssetImage from "../ImageUpload/AssetImage";
export default function AddEditAssetType({ open, onClose, mode, initialData }) {
  const [form, setForm] = useState({
    typeCode: "",
    typeName: "",
    notes: "",
  });

  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (mode === "edit" && initialData) {
      setForm({
        typeCode: initialData.typeCode || "",
        typeName: initialData.typeName || "",
        notes: initialData.notes || "",
      });
      setImage(null);
      setPreviewUrl(null);
      setErrors({});
    } else {
      setForm({ typeCode: "", typeName: "", notes: "" });
      setImage(null);
      setPreviewUrl(null);
      setErrors({});
    }
  }, [mode, initialData, open]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });

    // Clear error on change
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.type !== "image/png") {
      setErrors((prev) => ({ ...prev, image: "Only PNG images are allowed" }));
      e.target.value = "";
      return;
    }

    setErrors((prev) => ({ ...prev, image: "" }));
    setImage(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const validate = () => {
    const newErrors = {};

    if (!form.typeCode.trim()) newErrors.typeCode = "Type Code is required";
    if (!form.typeName.trim()) newErrors.typeName = "Type Name is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      const token = sessionStorage.getItem("token");

      const formData = new FormData();
        formData.append("typeCode", form.typeCode);
        formData.append("typeName", form.typeName);
        formData.append("notes", form.notes || "");
      formData.append(
        "data",
        new Blob([JSON.stringify(form)], { type: "application/json" })
      );
      if (image) formData.append("image", image);

      if (mode === "create") {
        await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/assets-type/create-asset-type`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
      } else {
       await axios.put(
            `${process.env.REACT_APP_API_BASE_URL}/api/assets-type/${initialData.identy}`,
            formData,
            {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            },
            }
        );
      }

      onClose();
    } catch (err) {
    console.error(err);

    if (err?.response?.status === 409) {
      alert("Duplicate Asset type – Asset type already exists");
    } else if (err?.response?.data?.message) {
      alert(err.response.data.message);
    } else {
      alert("Save failed. Please try again.");
    }
  }
  };

  

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
  <DialogTitle sx={{ fontWeight: 600 }}>
    {mode === "create" ? "Add Asset Type" : "Edit Asset Type"}
  </DialogTitle>

  <DialogContent>
    <Box
      display="grid"
      gridTemplateColumns={{ xs: "1fr", md: "2fr 1fr" }}
      gap={3}
      mt={1}
    >
      {/* Left: Form */}
      <Box display="flex" flexDirection="column" gap={2}>
        <TextField
          label="Type Code *"
          name="typeCode"
          value={form.typeCode}
          onChange={handleChange}
          error={!!errors.typeCode}
          helperText={errors.typeCode}
          fullWidth
        />

        <TextField
          label="Type Name *"
          name="typeName"
          value={form.typeName}
          onChange={handleChange}
          fullWidth
        />

        <TextField
          label="Notes"
          name="notes"
          value={form.notes}
          onChange={handleChange}
          error={!!errors.notes}
          helperText={errors.notes}
          multiline
          rows={4}
          fullWidth
        />

        <Button
          variant="outlined"
          component="label"
          sx={{
            height: 48,
            borderStyle: "dashed",
            textTransform: "none",
          }}
        >
          Upload PNG Image (Optional)
          <input hidden type="file" accept="image/png" onChange={handleFileChange} />
        </Button>

        {errors.image && (
          <Typography color="error" variant="caption">
            {errors.image}
          </Typography>
        )}

        {image && (
          <Typography variant="body2">
            Selected: <b>{image.name}</b>
          </Typography>
        )}
      </Box>

      {/* Right: Image Preview Card */}
      <Box
        sx={{
          border: "1px dashed #cfd8dc",
          borderRadius: 2,
          p: 2,
          minHeight: 220,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#fafafa",
        }}
      >
        <Typography variant="subtitle2" color="text.secondary" mb={1}>
          Preview
        </Typography>

        {previewUrl && (
          <img
            src={previewUrl}
            alt="preview"
            style={{
              width: "100%",
              maxHeight: 160,
              objectFit: "contain",
              borderRadius: 6,
            }}
          />
        )}

        {!previewUrl && mode === "edit" && initialData?.imagePath && (
          <AssetImage imagePath={initialData.imagePath} width={160} height={160} />
        )}

        {!previewUrl && !(mode === "edit" && initialData?.imagePath) && (
          <Typography variant="body2" color="text.secondary">
            No image selected
          </Typography>
        )}
      </Box>
    </Box>
  </DialogContent>

  <DialogActions sx={{ px: 3, pb: 2 }}>
    <Button onClick={onClose} sx={{ textTransform: "none" }}>
      Cancel
    </Button>
    <Button variant="contained" onClick={handleSubmit} sx={{ textTransform: "none" }}>
      {mode === "create" ? "Save" : "Update"}
    </Button>
  </DialogActions>
</Dialog>
  );
}